import { render, staticRenderFns } from "./MuteDemoIcon.vue?vue&type=template&id=13b759df&scoped=true&"
import script from "./MuteDemoIcon.vue?vue&type=script&lang=js&"
export * from "./MuteDemoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b759df",
  null
  
)

export default component.exports